// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTechnologyLightbulbLed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.666 4.646C8.108 5.56 8 6.607 8 7c0 .348.028.679.08 1h7.84c.052-.321.08-.652.08-1 0-.393-.108-1.44-.666-2.354C14.82 3.805 13.886 3 12 3c-1.886 0-2.82.805-3.334 1.646zM15.318 10H8.682a28.796 28.796 0 0 0 .491 1.114v.001C9.682 12.23 10.256 13.49 10.44 15h3.122c.184-1.51.758-2.77 1.265-3.885l.104-.228c.137-.302.268-.596.388-.887zM6.96 3.604C7.82 2.195 9.386 1 12 1c2.615 0 4.181 1.195 5.042 2.604C17.858 4.94 18 6.393 18 7c0 1.9-.653 3.4-1.248 4.712l-.071.158c-.58 1.276-1.075 2.366-1.166 3.698C15.463 16.322 14.847 17 14 17h-4c-.847 0-1.463-.678-1.515-1.432-.092-1.332-.586-2.422-1.166-3.698l-.071-.158C6.653 10.399 6 8.9 6 7c0-.607.142-2.06.96-3.396zM14 18a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2zm-4 3h4c-.068 1.204-.947 2-2.003 2-1.063 0-1.95-.796-1.997-2z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTechnologyLightbulbLed;
